import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideRouter } from '@angular/router'
import { provideHttpClient } from '@angular/common/http'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideStore } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'
import { HttpClient } from '@angular/common/http'
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler'
import { FirebaseApp, initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar'
import { provideNativeDateAdapter } from '@angular/material/core'
import { environment } from '../environments/environment'
import { FIREBASE_APP } from './app.tokens'
import { FIREBASE_STORAGE } from './common/FileService'
import { AuthModule } from '@/auth/auth.module'
import { FirestoreModule } from '@/common/firestore/firestore.module'

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter([
			{ path: '', loadChildren: () => import('./internal/internal.routes').then((m) => m.INTERNAL_ROUTES) },
			{ path: '', loadChildren: () => import('./public/public.routes').then((m) => m.PUBLIC_ROUTES) },
		]),
		provideHttpClient(),
		provideAnimations(),
		provideStore(),
		provideEffects(),
		provideNativeDateAdapter(),
		{
			provide: FIREBASE_APP,
			useFactory: () => initializeApp(environment.firebase),
		},
		{
			deps: [FIREBASE_APP],
			provide: FIREBASE_STORAGE,
			useFactory: (app: FirebaseApp) => {
				const storage = getStorage(app)
				if (environment.emulator) {
					connectStorageEmulator(storage, 'localhost', 9199)
				}
				return storage
			},
		},
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: { duration: 5000 },
		},
		importProvidersFrom(
			AuthModule.forRootAsync({
				deps: [FIREBASE_APP],
				useFactory: (app: FirebaseApp) => {
					const auth = getAuth(app)
					if (environment.emulator) {
						connectAuthEmulator(auth, `http://localhost:9099`, { disableWarnings: true })
					}
					return auth
				},
			}),
			FirestoreModule.forRootAsync({
				deps: [FIREBASE_APP],
				useFactory: (app: FirebaseApp) => {
					const firestore = getFirestore(app)
					if (environment.emulator) {
						connectFirestoreEmulator(firestore, `localhost`, 8080)
					}
					return firestore
				},
			}),
			TranslateModule.forRoot({
				defaultLanguage: 'en',
				loader: {
					deps: [HttpClient],
					provide: TranslateLoader,
					useFactory: (http: HttpClient) => {
						return new TranslateHttpLoader(http, './assets/i18n/', '.json')
					},
				},
				compiler: {
					provide: TranslateCompiler,
					useFactory: () => {
						return new TranslateMessageFormatCompiler()
					},
				},
			})
		),
	],
}
